<template>
  <div class="fp-step">
    <h1 class="fp-step-title">{{ title }}</h1>

    <div class="fp-form-group">
      <div class="fp-info-text">
        {{ message }}
      </div>
    </div>

    <button class="fp-btn-primary" @click="$emit('go-to-login')" t_label="btn_emp2_BackToLogin_ForgotPasswordSuccess">
      {{ $t('lbl_emp2_BackToLogin') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ForgotPasswordSuccess',
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['email', 'mobile'].includes(value);
      }
    }
  },
  computed: {
    title() {
      return this.type === 'mobile' ? this.$t('lbl_emp2_CheckYourSMS') : this.$t('lbl_emp2_CheckYourMailbox');
    },
    message() {
      return this.type === 'mobile'
        ? this.$t('lbl_emp2_PasswordSentToMobile')
        : this.$t('lbl_emp2_PasswordSentToEmail');
    }
  }
};
</script>

<style scoped>
.fp-step {
  gap: 24px !important;
  margin: -40px -24px !important;
  padding: 40px 24px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  width: calc(100% + 48px) !important;
  align-self: stretch !important;
}

.fp-step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
}

.fp-form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.fp-info-text {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  text-align: left;
}
</style>

